// 选择器在 mixin 里。再包一层 :root 的话，暗色会变成后代，data-theme-type 对不上
@include color-tokens;
